import React from 'react';
import SliceStep2 from './SliceStep2';
import './Wheel.css';

const WEDGE_PATH =
    'M93 7.241a200.006 200.006 0 01200.551-.865L200.004 200 112.33 20.241z';

const sliceRotation = (index, areaId) =>
    areaId === 1
        ? 'rotate(81.42,220,220)'
        : `rotate(${132.84 + 51.42 * (index - 1)},220,220)`;

const Wheel = (state) => {
    const maskId = state.maskId || 'wedge-mask';
    const overlayId = state.overlayId || 'overlay';
    const currentF = state.AllState?.CurrentF;
    const showTotal = currentF == -1 || state.allColors === true;
    const lastReachedIndex =
        state.lastReachedIndex != null
            ? state.lastReachedIndex
            : state.AllState?.LastReachedF;
    const goalProgress = state.goalProgress === true;
    const onSelectF = state.onSelectF;
    const pick7Browse = state.pick7Browse === true;
    const onSelectCategory = state.onSelectCategory;
    const activeCategoryIndex = state.activeCategoryIndex;
    const pick7Interactive =
        pick7Browse && typeof onSelectCategory === 'function';
    const interactive =
        goalProgress &&
        typeof onSelectF === 'function' &&
        currentF >= 0 &&
        currentF !== -1 &&
        state.allColors !== true;

    const handleSliceSelect = (index) => {
        if (!interactive) return;
        if (
            Number.isFinite(lastReachedIndex) &&
            index > lastReachedIndex
        ) {
            return;
        }
        onSelectF(index);
    };

    const handlePick7CategorySelect = (index) => {
        if (!pick7Interactive) return;
        onSelectCategory(index);
    };

    function addZeroes(num, places) {
        const dec = String(num).split('.')[1];
        const len = dec && dec.length > places ? dec.length : places;
        return Number(num).toFixed(len);
    }

    const scoreLabel = showTotal
        ? 'TOTAL SCORE'
        : `${String(state.AllState.Fs[currentF].name).toUpperCase()} SCORE`;

    const scoreValue = showTotal
        ? Math.round(state.AllState.latestAssessmentScore, 0)
        : addZeroes(state.AllState.Fs[currentF].score, 1);

    const scoreColor = showTotal
        ? 'var(--blue-dark)'
        : state.AllState.Fs[currentF].color;

    const WheelR = (
        <div
            className="selectGoalWheel__container"
            style={{ height: '100%', marginTop: '-5%' }}
        >
            <div className="selectGoalWheel__wheelWrap">
                <svg
                    className={`selectGoalWheel__wheelStep2${
                        interactive || pick7Interactive
                            ? ' selectGoalWheel__wheelStep2--interactive'
                            : ''
                    }`}
                    viewBox="0 0 440 440"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                        transform: `rotate(${String(-51.42)}deg)`,
                        animation: `spin ${state.confetti * 2.5}s linear `,
                    }}
                >
                    <defs>
                        <g id={overlayId}>
                            <rect
                                x="219"
                                y="20"
                                height="200"
                                width="10"
                                fill="#FFF"
                            />
                        </g>
                    </defs>
                    <mask id={maskId} fill="white">
                        <path
                            transform="translate(20, 20)"
                            d="M93 7.241a200.006 200.006 0 01200.551-.865L200.004 200 112.33 20.241z"
                            fillRule="nonzero"
                        />
                    </mask>
                    {state.AllState?.Fs?.map((item, i) => (
                        <SliceStep2
                            key={i}
                            index={i}
                            Fs={item}
                            FullState={state.AllState}
                            allColors={state.allColors}
                            maskId={maskId}
                            highlightIndex={
                                pick7Browse ? activeCategoryIndex : undefined
                            }
                            showSliceScores={state.showSliceScores === true}
                        />
                    ))}
                    <g className="selectGoalWheel__decor" aria-hidden="true">
                    <circle
                        cx="220"
                        cy="220"
                        r="48"
                        fill="white"
                        strokeWidth="1"
                    />
                    <circle
                        cx="220"
                        cy="220"
                        r="40"
                        fill="#C9C9C9"
                        strokeWidth="1"
                    />
                    <use
                        xlinkHref={`#${overlayId}`}
                        transform="rotate(56, 222, 220)"
                    />
                    <use
                        xlinkHref={`#${overlayId}`}
                        transform="rotate(107.13, 220, 220)"
                    />
                    <use
                        xlinkHref={`#${overlayId}`}
                        transform="rotate(159.55, 222, 220)"
                    />
                    <use
                        xlinkHref={`#${overlayId}`}
                        transform="rotate(209.97, 220, 223)"
                    />
                    <use
                        xlinkHref={`#${overlayId}`}
                        transform="rotate(262, 220, 222)"
                    />
                    <use
                        xlinkHref={`#${overlayId}`}
                        transform="rotate(310.91, 218, 223)"
                    />
                    <use
                        xlinkHref={`#${overlayId}`}
                        transform="rotate(364.23, 227, 208)"
                    />
                    <circle
                        cx="220"
                        cy="220"
                        r="30"
                        fill="#FFF"
                        strokeWidth="1"
                    />
                    </g>
                    {interactive || pick7Interactive ? (
                        <g className="selectGoalWheel__hitLayer">
                            {state.AllState.Fs.map((item, i) => {
                                const locked =
                                    !pick7Interactive &&
                                    Number.isFinite(lastReachedIndex) &&
                                    i > lastReachedIndex;
                                return (
                                    <g
                                        key={`hit-${item.areaId ?? i}`}
                                        transform={sliceRotation(
                                            i,
                                            item.areaId
                                        )}
                                    >
                                        <path
                                            className={`selectGoalWheel__sliceHit${
                                                locked
                                                    ? ' selectGoalWheel__sliceHit--locked'
                                                    : ''
                                            }${
                                                pick7Interactive &&
                                                i === activeCategoryIndex
                                                    ? ' selectGoalWheel__sliceHit--pick7-active'
                                                    : ''
                                            }`}
                                            transform="translate(20, 20)"
                                            d={WEDGE_PATH}
                                            fill="currentColor"
                                            fillOpacity="0.001"
                                            pointerEvents={
                                                locked ? 'none' : 'all'
                                            }
                                            onPointerUp={(event) => {
                                                if (
                                                    locked ||
                                                    event.button > 0
                                                ) {
                                                    return;
                                                }
                                                event.stopPropagation();
                                                event.preventDefault();
                                                if (
                                                    typeof event.currentTarget
                                                        .blur === 'function'
                                                ) {
                                                    event.currentTarget.blur();
                                                }
                                                if (pick7Interactive) {
                                                    handlePick7CategorySelect(i);
                                                } else {
                                                    handleSliceSelect(i);
                                                }
                                            }}
                                        />
                                    </g>
                                );
                            })}
                            <circle
                                className="selectGoalWheel__hubBlocker"
                                cx="220"
                                cy="220"
                                r="52"
                                fill="transparent"
                                pointerEvents="all"
                            />
                        </g>
                    ) : null}
                </svg>
                <div
                    className="selectGoalWheel__centerLogo"
                    aria-hidden="true"
                />
            </div>
            <div className="selectGoalWheel__scoreBelow">
                <p className="selectGoalWheel__scoreLabel">{scoreLabel}</p>
                <p
                    className="selectGoalWheel__scoreValue"
                    style={{ color: scoreColor }}
                >
                    {scoreValue}
                </p>
            </div>
        </div>
    );

    return WheelR;
};
export default Wheel;
